<template>
	<currency-input
		v-model="inputValue"
		class="currency-input body-text-2"
		:placeholder="placeholder"
		:currency="currency"
		:locale="locale"
		:auto-decimal-mode="autoDecimal"
		:allow-negative="allowNegative"
		:precision="precision"
		:distraction-free="inputConfig"
		:value-range="rangeValue"
		autocomplete="off"
		@input="onInput"
		@blur.native="checkMinValue"
	/>
</template>
<script>
export default {
	props: {
		value: {
			type: Number,
			default: 0
		},
		placeholder: {
			type: String,
			default: `0`
		},
		max: {
			type: Number,
			default: 10000000
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			inputValue: this.value,
			currency: this.$t('currency'),
			locale: 'en-US',
			autoDecimal: true,
			allowNegative: false,
			precision: 0,
			inputConfig: {
				hideNegligibleDecimalDigits: false,
				hideCurrencySymbol: false,
				hideGroupingSymbol: false
			},
			rangeValue: {
				min: 0,
				max: this.max
			}
		};
	},
	watch: {
		value(newValue) {
			this.inputValue = newValue;
		},
		max(newVal) {
			this.rangeValue.max = newVal;
		}
	},
	methods: {
		checkMinValue() {
			if (this.inputValue === null) {
				this.inputValue = 0;
			}
		},
		onInput() {
			this.checkMinValue();
			this.$emit('input', this.inputValue);
		}
	}
};
</script>
<style lang="scss" scoped>
.currency-input {
	width: 100%;
	height: 48px;
	border-radius: 4px;
	background-color: #ffffff;
	border: 1px solid #dde4e6;
	color: #687682;
	text-indent: 16px;
	cursor: auto;

	&.disabled {
		margin: 0px;
	}
}
</style>
